import { render } from "./BgSlot.vue?vue&type=template&id=3f8fb6bc&scoped=true&ts=true"
import script from "./BgSlot.vue?vue&type=script&lang=ts"
export * from "./BgSlot.vue?vue&type=script&lang=ts"

import "./BgSlot.vue?vue&type=style&index=0&id=3f8fb6bc&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8fb6bc"]])

export default __exports__